import React, { Fragment, useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useStateValue } from '@State'
import { client } from '@Utils'
import { ContextAttributes } from './ContextAttributes'
import { ContextCoursesTable } from './ContextCoursesTable'
import { ltiOrgKeyManagement as endpoints } from '@URLS'

export const ContextDetails = props => {
  const [currentState] = useStateValue()
  const [context, setContext] = useState(null)
  useEffect(() => {
    const fetchData = async () => {
      let resp = await client.get(
        endpoints.getContextDetails({ contextId: props.contextId })
      )
      setContext(resp.data.context)
    }
    try {
      fetchData()
    } catch (err) {
      console.log(err)
    }
  }, [currentState.reloadSwitch])

  let component =
    context === null ? (
      <p>Loading ...</p>
    ) : (
      <Fragment>
        <ContextAttributes context={context} />
        <ContextCoursesTable context={context} />
      </Fragment>
    )

  return <Fragment>{component}</Fragment>
}

ContextDetails.propTypes = {
  contextId: PropTypes.string.isRequired,
}
